/* globals lp, jui, eventTracker, Class */

var Rx = require('ub_wrapped/rx');
var _ = require('lodash');
var ubBanzai = require('ub/control/banzai-features');
var FormSanitizer = require('ub/data/filters/form-sanitizer');

var rxUi = window.rxUi;

module.exports = Class.create(lp.editor.BuilderModal, {
  formIdRegExp: /[!@#$%\^&*()+'‘’"“”":;?\[\]<>\/.,{}\\=\-|~`]/,
  invalidFieldNameWarningMessage: [
    'You cannot have duplicate form field names.',
    'They cannot be blank nor can they include only special characters.'
  ].join(' '),

  initialize: function($super){
    var self         = this;

    this._uiBinding  = new rxUi.Binding('FormElementBuilder');

    this.controls    = {};
    this.form        = null;
    this.fields      = [];
    this.elmMap      = [];
    this.activeField = null;

    $super({
      title:'Design Your Form',
      clickOutsideWillClose: false,
      attributes: {
        className: 'modal-panel form-builder-panel responsive-panel'
      },
      actions: [
        {
          id:     'doneButton',
          label:  'Done',
          'class':'action form-builder-action',
          action: function() {
            self._uiBinding.onNext({
              type:   'finishEditingFields',
              fields: self.fields
            });
          }
        },
        {
          id:     'cancelButton',
          label:  'Cancel',
          'class': 'push-left',
          action: function() {
            self._uiBinding.onNext({type: 'cancelEditingFields'});
          }
        }
      ],
      closeX: true
    });

    this._uiBinding.subscribeDomainEvents(this.domainEvents, this);
  },

  domainEvents: {
    finishEditingFields: function(ev) {
      var fields = ev.fields;
      var validator = new lp.module.form.FormBuilderValidator(fields);

      if (fields.collect(function(field) {return field.type !== 'hidden' ? field : null;}).compact().length === 0) {
        this.warn.update('Your form must contain at least one field that is visible');
        this.warn.show();
      } else if (validator.isValid()) {
        this.warn.hide();
        this.editControls.clear();

        if (this.options.callback) {
          this.options.callback(fields);
        }

        this.close();
        if(typeof eventTracker !== 'undefined') {
          eventTracker.track("Add a Form", "Editor");
        }
      } else {
        this.warn.update(this.invalidFieldNameWarningMessage);
        this.warn.show();
      }
    },
    cancelEditingFields: function() {
      this.editControls.clear();
      this.close();
    }
  },

  installUI: function( $super ) {
    $super();

    this.designer = this.contentPanel.insert( new jui.Component({attributes:{className:'form-designer form-builder-form-designer'}}));
    this.buildControls = this.designer.insert( new jui.Component({attributes:{className:'build-controls form-builder-build-controls form-builder-column'}}));
    this.fieldset = this.designer.insert( new jui.Component({attributes:{className:'fieldset-view form-builder-fieldset-view form-builder-column'}}));
    this.editControls = this.designer.insert( new jui.Component({attributes:{className:'edit-controls form-builder-edit-controls form-builder-column'}}));

    this.warn = this.actionBar.insert( new Element('div', {className:'warn'}).update(this.invalidFieldNameWarningMessage));
    this.warn.hide();

    this.formItemControls = new Element('div', {className:'form-builder-item-controls'});

    var moveUpButton = 'svg-ico-move-up';
    var moveDownButton = 'svg-ico-move-down';

    this.moveUpButton = new jui.IconButton('move-up item-control-button ' + moveUpButton, {action:this.moveFieldUp.bind(this)});
    this.moveDownButton = new jui.IconButton('move-down item-control-button ' + moveDownButton, {action:this.moveFieldDown.bind(this)});
    this.deleteButton = new jui.IconButton('delete svg-ico-delete item-control-button', {action:this.deleteField.bind(this)});

    this.installBuildControls();
    this.createFieldEditors();
    this.createFieldViews();
  },

  updateLayout: function($super) {
    this.setDimensions(jui.Dimensions.add({width:6, height:81}, this.designer.getDimensions()));
    $super();
  },

  installBuildControls: function() {
    var self = this;

    this.buildControls.insert(new Element('h3', {className:'field-builder-controls-header'}).update('Custom Fields'));

    function fieldNamer(type){
      switch (type) {
        case 'name':
          return self.fields.length > 0 ? 'Untitled' + self.fields.length : 'Untitled';
        case 'id':
          return self.fields.length > 0 ? 'untitled' + self.fields.length : 'untitled';
      }
    }

    this.controls.addDropdown = this.buildControls.insert(new jui.PopUpButton(
          new jui.Menu({
            items:[
            {type:'item', label:"Single Line Text Field", tag:"single"},
            {type:'item', label:"Multi Line Text Field", tag:"multi"}
            ],
            action:function(e) {
              var type = e.data.selectedItem.tag;

              switch (type) {
                case 'single':
                  self.addField(
                      {
                        name:fieldNamer('name'),
                        id:fieldNamer('id'),
                        placeholder:'',
                        type:'text',
                        lpType:'single-line-text',
                        show:{
                          phone:false,
                          email:false
                        },
                        validations:{
                          required:false
                        }
                      }
                      );
                  break;

                case 'multi':
                  self.addField(
                      {
                        name:fieldNamer('name'),
                        id:fieldNamer('id'),
                        type:'textarea',
                        lpType:'multi-line-text',
                        heightUnits: 'lines',
                        numberOfLines:4,
                        pixelHeight:80,
                        show:{
                          phone:false,
                          email:false
                        },
                        validations:{
                          required:false
                        }
                      }
                      );
                  break;
              }
            }
          }),
          {label:'Text Field',
            attributes: {
              className: 'button popup add-text-field'
            },
            action:function(){
              // no-op
            }
          }
    ));

    this.controls.addTextCheckboxes = this.buildControls.insert(new jui.Button({label:'Checkboxes',
      attributes:{
        className: 'button add-checkboxes'
      },
      action: function(){
        self.addField({
          name:fieldNamer('name'),
          id:fieldNamer('id'),
          type:'checkbox',
          lpType:'checkbox-group',
          options:[{value:'choice_1', label:'Choice 1'}, {value:'choice_2', label:'Choice 2'}, {value:'choice_3', label:'Choice 3'}],
          validations:{
            required:false
          }
        });
      }
    }));

    if (window.editor.mainPage.getConfigValue('allowFormRadioFields')) {
      this.controls.addTextRadios = this.buildControls.insert(new jui.Button({label:'Radio Buttons',
        attributes:{
          className: 'button add-radio-button'
        },
        action:function(){
          self.addField({
            name:fieldNamer('name'),
            id:fieldNamer('id'),
            type:'radio',
            lpType:'radio-group',
            options:[{value:'choice_1', label:'Choice 1'}, {value:'choice_2', label:'Choice 2'}, {value:'choice_3', label:'Choice 3'}],
            validations:{
              required:false
            }
          });
        }
      }));
    }

    this.controls.addDropdown = this.buildControls.insert(new jui.PopUpButton(
          new jui.Menu({
            items:[
            {type:'item', label:"Custom Drop-down Menu", tag:"custom"},
            {type:'divider'},
            {type:'item', label:"Country", tag:"country"},
              {type:'item', label:"State", tag:"state"},
              {type:'item', label:"Province", tag:"province"},
                {type:'item', label:"State/Province", tag:"state-province"},
                {type:'divider'},
                  {type:'item', label:'Gender', tag:'gender'},
                  {type:'item', label:'Age', tag:'age'},
                    {type:'item', label:'Income', tag:'income'},
                    {type:'divider'},
                      {type:'item', label:'Day of the Week', tag:'day'},
                      {type:'item', label:'Month', tag:'month'},
                        {type:'item', label:'Time Zone', tag:'timezone'}
            ],
            action:function(e) {
              var menu = e.data;
              var invalidOptions = [];
              var required = false;
              // TODO: this should be compiled in from a db-controlled list -pk
              var preDefinedOptions = {
                'country':["Select a Country", "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo, Democratic Republic", "Congo, Republic of the", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "East Timor", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Greenland", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico", "Micronesia", "Moldova", "Mongolia", "Morocco", "Monaco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Samoa", "San Marino", "Sao Tome", "Saudi Arabia", "Senegal", "Serbia and Montenegro", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "Spain", "Sri Lanka", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"],
                'state':["Select a State", "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"],
                'province':["Select a Province", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon Territory"],
                  'state-province':["Select a State or Province", "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "District of Columbia", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Yukon Territory"],
                'gender':["Select your Gender", "Male", "Female"],
                'age':["Select an Age Group", "Under 18", "18-25", "26-35", "36-45", "46-55", "56-65", "Over 65"],
                'income':['Select a One', "Under $20,000","$20,000 - $30,000","$30,000 - $40,000","$40,000 - $50,000","$50,000 - $75,000","$75,000 - $100,000","$100,000 - $150,000","$150,000 or more"],
                'day':['Select a Day', "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
                'month':["Select a Month", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                'timezone':["Select a Time Zone", "(GMT-12:00) - Eniwetok, Kwajalein", "(GMT-11:00) - Midway Island, Samoa", "(GMT-10:00) - Hawaii", "(GMT-9:00) - Alaska", "(GMT-8:00) - Pacific Time (US & Canada), Tijuana", "(GMT-7:00) - Arizona", "(GMT-7:00) - Mountain Time (US & Canada)", "(GMT-6:00) - Central Time (US & Canada)","(GMT-6:00) - Mexico City, Teguagalpu","(GMT-6:00) - Saskatchewan","(GMT-5:00) - Bogota, Lima","(GMT-5:00) - Eastern Time (US & Canada)","(GMT-5:00) - Indiana (East)","(GMT-4:00) - Atlantic Time (Canada)","(GMT-4:00) - Caracas, La Puz","(GMT-3:30) - New Foundland","(GMT-3:00) - Brasilia, Buenos Aires, Georgetown","(GMT-2:00) - Mid Atlantic","(GMT-1:00) - Azores, Cape Verde Is.","(GMT) - Greenwich Mean Time, Dublin, Edinburgh, London","(GMT) - Monrovia, Casablanca","(GMT+1:00) - Berlin, Stockholm, Rome, Bern","(GMT+1:00) - Brussels, Vienna, Amsterdam","(GMT+1:00) - Lisbon, Warsaw","(GMT+1:00) - Paris, Madrid","(GMT+1:00) - Prague","(GMT+2:00) - Athens, Helsinki, Istanbul","(GMT+2:00) - Cairo","(GMT+2:00) - Eastern Europe","(GMT+2:00) - Harare, Pretoria","(GMT+2:00) - Israel","(GMT+3:00) - Baghdad, Kuwait, Nairobi, Riyadh","(GMT+3:00) - Moscow, St.Petersburg","(GMT+3:30) - Tehran","(GMT+4:00) - Abu Dhabi, Muscat, Tbilisi, Kazan, volgograd","(GMT+4:30) - Kabul","(GMT+5:00) - Islamabad, Karachi, Ekaterinburg, Tashkent","(GMT+5:30) - Bombay, Calcutta, Madras, New Delhi","(GMT+6:00) - Almaty, Dhaka","(GMT+7:00) - Bangkok, Jakarta, Hanoi","(GMT+8:00) - Beijing, Chongking, Urumqi","(GMT+8:00) - Hong Kong, Perth, Singapore, Taipei","(GMT+9:00) - Tokyo, Osaka, Sapporo, Seoul, Yakutsk","(GMT+9:30) - Adelaide","(GMT+9:30) - Darwin","(GMT+10:00) - Brisbane, Melbourne, Sydney","(GMT+10:00) - Guam, Port Moresby, Vladivostok","(GMT+10:00) - Hobart","(GMT+11:00) - Magadan, Solomon Is., New Caledonia","(GMT+12:00) - Fiji, Kamchatka, Marshall Is.","(GMT+12:00) - Wellington, Auckland"]
              };

              var selectOptions = preDefinedOptions[menu.selectedItem.tag] || [];
              var name = menu.selectedItem.tag === 'custom' ? 'Untitled Menu' : menu.selectedItem.labelText;
              if (menu.selectedItem.tag !== 'custom') {
                invalidOptions.push(0);
                required = true;
              }

              self.addField(
                  {
                    name:name,
                    id:self.generateFieldId(name),
                    type:'text',
                    lpType:'drop-down',
                    selectOptions:selectOptions,
                    invalidOptions:invalidOptions,
                    validations:{
                      required:required
                    }
                  }
                  );
            }
          }),
          {label:'Drop-down menu',
            attributes: {
              className: 'button popup add-drop-down'
            },
            action:function(){
              // no-op
            }
          }
    ));

    this.controls.addHiddenField = this.buildControls.insert(new jui.Button({label:'Hidden Field',
      attributes:{
        className: 'button add-hidden-field'
      },
      action:function(){
        self.addField({
          name:fieldNamer('name'),
          id:fieldNamer('id'),
          type:'hidden',
          lpType:'hidden',
          value:''
        });
      }
    }));

    this.buildControls.insert(new Element('div', {className:'spacer'}));
    this.buildControls.insert(new Element('h3', {className:'field-builder-controls-header'}).update('Pre-defined Fields'));

    this.controls.addEmailField = this.buildControls.insert(new jui.Button({label:'Email',
      attributes:{
        className: 'button add-email-field'
      },
      action:function(){
        self.addField({
          name:'Email',
          id:'email',
          placeholder:'',
          type:'text',
          lpType:'email',
          show:{
            phone:false,
            email:true
          },
          validations:{
            required:false,
            email:true
          }
        });
      }
    }));

    this.controls.addFirstNameField = this.buildControls.insert(new jui.Button({label:'First Name',
      attributes:{
        className: 'button add-first-name-field'
      },
      action:function(){
        self.addField({
          name:'First Name',
          id:'first_name',
          placeholder:'',
          type:'text',
          lpType:'single-line-text',
          show:{
            phone:false,
            email:false
          },
          validations:{
            required:false
          }
        });
      }
    }));

    this.controls.addLastNameField = this.buildControls.insert(new jui.Button({label:'Last Name',
      attributes:{
        className: 'button add-last-name-field'
      },
      action:function(){
        self.addField({
          name:'Last Name',
          id:'last_name',
          placeholder:'',
          type:'text',
          lpType:'single-line-text',
          show:{
            phone:false,
            email:false
          },
          validations:{
            required:false
          }
        });
      }
    }));

    this.controls.addPhoneField = this.buildControls.insert(new jui.Button({label:'Phone Number',
      attributes:{
        className: 'button add-phone-number-field'
      },
      action:function(){
        self.addField({
          name:'Phone Number',
          id:'phone_number',
          placeholder:'',
          type:'text',
          lpType:'single-line-text',
          validationType: 'north-american',
          show:{
            phone:true,
            email:false
          },
          validations:{
            required:false,
            phone:true
          }
        });
      }
    }));

    this.controls.addAgeField = this.buildControls.insert(new jui.Button({label:'Age',
      attributes:{
        className: 'button add-age-field'
      },
      action:function(){
        self.addField({
          name:'Age',
          id:'age',
          placeholder:'',
          type:'text',
          lpType:'single-line-text',
          show:{
            phone:false,
            email:false
          },
          validations:{
            required:false
          }
        });
      }
    }));
  },

  toggleLabelAsReqired: function(label, isRequired) {
    var labelText = label.innerHTML;
    if(isRequired) {
      labelText += ' *';
    } else {
      labelText = labelText.gsub(/\s\*$/, '');
    }
    label.update(labelText);
  },

  generateFieldId: function(fieldLabel) {
    return this.sanitizeFieldId(fieldLabel.toLowerCase());
  },

  sanitizeFieldId: function(id) {
    var _id = id.stripTags();
    _id = _id.replace(/\s/g, '_'); // don't collapse spaces
    _id = FormSanitizer.removeBadChars(_id);
    _id = _id.replace(/[\t\r\n]+/g, '_'); // collapse tabs and line wrapping
    return _id;
  },

  _updateGeneratedFieldId: function(fieldNameAndID, autoGenerateFieldID, id) {
    if (autoGenerateFieldID.getValue()) {
      this.setFieldAttribute('id', id);
      fieldNameAndID.setValue(id);
    }
  },

  createFieldEditors: function() {
    var self = this;

    var getNameAndIdField = function() {
      var elm = new jui.FormTextInput({
        inputPosition:'clear-label',
        readonly: true,
        classNames:['field-name-id', 'disabled']
      });

      //TODO: dispose the subscription when the form builder is exited
      Rx.Observable.fromEvent(elm.input, 'input')
        .map(function(){
          return elm.input.getValue().stripScripts();
        })
      .map(self.sanitizeFieldId.bind(self))
        .subscribe(function(sanitizedId) {
          self.setFieldAttribute('id', sanitizedId);
          var origValue = elm.input.getValue();
          if (origValue !== sanitizedId) {
            var cursor = elm.input.selectionStart;
            elm.setValue(sanitizedId);
            if (elm.input.setSelectionRange) {
              if (origValue.length > sanitizedId.length) {
                cursor--;
              }
              elm.input.setSelectionRange(cursor, cursor);
            }
          }
        });

      return elm;
    };

    var getAutoGeneratedFieldId = function(label, fieldNameAndID) {
      return new jui.FormCheckboxInput({
        label: 'Auto-generate from Field Label',
        checked: true,
        inputId: 'auto-generate-checkbox',
        classNames: ['field-checkbox'],
        onclick: function(e) {
          if (e.source.getValue()){
            fieldNameAndID.input.readOnly = 'readonly';
            fieldNameAndID.input.disabled = 'disabled';

            // reset value
            var v = label.getValue().stripScripts();
            var id = self.generateFieldId(v);
            self.setFieldAttribute('id', id);
            fieldNameAndID.setValue(id);
          } else {
            fieldNameAndID.input.removeAttribute('readonly');
            fieldNameAndID.input.removeAttribute('disabled');
          }
        }
      });
    };
    var setAutoGeneratedFieldNameAndId = function(field, autoGenerateFieldID, fieldNameAndID) {
      if (self.generateFieldId(field.name) === field.id) {
        autoGenerateFieldID.checkbox.checked = true;
        fieldNameAndID.input.readOnly = 'readonly';
        fieldNameAndID.input.disabled = 'disabled';
      } else {
        autoGenerateFieldID.checkbox.checked = false;
        fieldNameAndID.input.removeAttribute('readonly');
        fieldNameAndID.input.removeAttribute('disabled');
      }
    };

    this.fieldEditors = [
    {
      types:['single-line-text', 'email'],
      editor:(function() {
        var fieldNameAndID;
        var autoGenerateFieldID;

        var activeField = null;
        var activeElement = null;
        var base = new jui.Component({attributes:{className:'field-editor'}});
        var fs1 = base.insert(new jui.Component({elementType:'fieldset'}));
        fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Label'));

        var label = fs1.insert(new jui.FormTextInput({
          inputPosition:'clear-label',
          classNames:['label-input'],
          onkeyup: function(e) {
            var v = e.source.getValue().stripScripts();
            var id = self.generateFieldId(v);
            self.setFieldAttribute('name', v);
            activeElement.root.e.down('label').update(v);
            self._updateGeneratedFieldId(fieldNameAndID, autoGenerateFieldID, id);
          }
        }));

        var hideLabel = fs1.insert(new jui.FormCheckboxInput({
          label: 'Hide label',
          classNames: ['field-checkbox'],
          inputId: 'single-line-text-hide-label-checkbox',
          onclick: function(e) {
            var hide = e.source.getValue();
            self.setFieldAttribute('hideLabel', hide);

            var visibility = hide ? 'hidden' : 'visible';
            activeElement.root.e.down('label').setStyle({'visibility': visibility});
          }
        }));

        if (window.editor.page.getConfigValue('showFormBuilderPlaceholderInput') && ubBanzai.features.isFormBuilderPlaceholderInputEnabled()) {
          fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Placeholder Text'));
          var placeholder = fs1.insert(new jui.FormTextInput({
            inputPosition:'clear-label',
            classNames:['label-input'],
            onkeyup: function(e) {
              var v = e.source.getValue().stripScripts();
              self.setFieldAttribute('placeholder', v);
              activeElement.root.e.down('input').setAttribute('placeholder', v);
            }
          }));
        }

        fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Name and ID'));

        fieldNameAndID = fs1.insert(getNameAndIdField());
        autoGenerateFieldID = fs1.insert(getAutoGeneratedFieldId(label, fieldNameAndID));

        var fs2 = base.insert(new jui.Component({elementType:'fieldset'}));

        fs2.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Validation Options'));
        var required = fs2.insert(new jui.FormCheckboxInput({
          label: 'Required field',
          inputId: 'single-line-text-required-checkbox',
          onclick: function(e) {
            self.setFieldAttribute('validations.required', e.source.getValue());
            var label = activeElement.root.e.down('label');
            self.toggleLabelAsReqired(label, e.source.getValue());
          }
        }));

        var validateEmail = fs2.insert(new jui.FormCheckboxInput({
          label: 'Validate as email address',
          inputId: 'validate-email-checkbox',
          onclick: function(e) {
            self.setFieldAttribute('validations.email', e.source.getValue());
          }
        }));

        var validatePhone = fs2.insert(new jui.FormCheckboxInput({
          label: 'Validate phone number as: ',
          attributes: {className: 'form-elm checkbox-input phone'},
          inputId: 'validate-phone-checkbox',
          onclick: function(e) {
            self.setFieldAttribute('validations.phone', e.source.getValue());
          }
        }));

        var aboutPhone = {
          'north-american': 'Validate that the phone number is either a landline or mobile number in North America.',
          'uk': 'Validate that the phone number is either a landline or mobile number in the United Kingdom.',
          'australian': 'Validate that the phone number is either a landline or mobile number in Australia.',
          'generic': 'Validate that the phone number has between 6 and 12 numbers, allowing for special characters.'
        };

        var phoneValidationType = fs2.insert(new jui.FormSelect({
          width: '150px',
          attributes: {className: 'form-elm select phone-type-dropdown'},
          label: null,
          id: 'jui-phone-validation-type',
          dropDownClassName: 'modal-select2-dropdown jui-drop-down',
          selectOptions:[
          {name:'North American', value:'north-american'},
          {name:'United Kingdom', value:'uk'},
          {name:'Australian', value:'australian'},
            {name:'Generic', value:'generic'}
          ],
          action: function(e) {
            self.setFieldAttribute('validationType', e.source.getValue().stripScripts());
            aboutPhoneType.update(aboutPhone[e.source.getValue().stripScripts()]);
          }
        }));

        var aboutPhoneType = new Element('p', {className:'about-phone'}).update(aboutPhone['north-american']);

        fs2.insert(aboutPhoneType);

        var setPlaceHolderValue = function(form) {
          if (window.editor.page.getConfigValue('showFormBuilderPlaceholderInput') && ubBanzai.features.isFormBuilderPlaceholderInputEnabled()) {
            placeholder.setValue(form.placeholder || '');
          }
        };

        return {
          getRootElement: function() { return base;},
          setField: function(f, e) {
            activeField = f;
            activeElement = e;
            label.setValue(f.name);
            fieldNameAndID.setValue(f.id);
            setPlaceHolderValue(f);
            setAutoGeneratedFieldNameAndId(f, autoGenerateFieldID, fieldNameAndID);
            var validationType = f.validationType || 'north-american';
            hideLabel.setValue(f.hideLabel ? true : false);
            required.setValue(f.validations.required);
            validateEmail.setValue(Object.isUndefined(f.validations.email) ? false : f.validations.email);
            validatePhone.setValue(Object.isUndefined(f.validations.phone) ? false : f.validations.phone);
            phoneValidationType.setSelectedValue(validationType);
            aboutPhoneType.update(aboutPhone[validationType]);

            if (Object.isUndefined(f.show)) {
              f.show = {};
              if(f.id === 'email' || f.validations.email === true) {
                f.show.email = true;
              }
              if(f.id === 'phone_number') {
                f.show.phone = true;
              }
            }

            validateEmail.setVisible(f.show.email);
            validatePhone.setVisible(f.show.phone);
            phoneValidationType.setVisible(f.show.phone);

            aboutPhoneType.setStyle({display: f.show.phone ? 'block' : 'none'});
          }
        };
      })()
    },

    {
      types:['multi-line-text'],
      editor:(function() {
        var fieldNameAndID;
        var autoGenerateFieldID;

        var activeField = null;
        var activeElement = null;
        var base = new jui.Component({attributes:{className:'field-editor'}});
        var fs1 = base.insert(new jui.Component({elementType:'fieldset'}));
        fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Label'));
        var label = fs1.insert(new jui.FormTextInput({
          inputPosition:'clear-label',
          classNames:['label-input'],
          onkeyup: function(e) {
            var v = e.source.getValue().stripScripts();
            var id = self.generateFieldId(v);
            self.setFieldAttribute('name', v);
            activeElement.root.e.down('label').update(v);
            self._updateGeneratedFieldId(fieldNameAndID, autoGenerateFieldID, id);
          }
        }));

        var hideLabel = fs1.insert(new jui.FormCheckboxInput({
          label:'Hide label',
          classNames:['field-checkbox'],
          inputId: 'multi-line-text-hide-label-checkbox',
          onclick: function(e) {
            var hide = e.source.getValue();
            self.setFieldAttribute('hideLabel', hide);
            var visibility = hide ? 'hidden' : 'visible';
            activeElement.root.e.down('label').setStyle({'visibility': visibility});
          }
        }));

        fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Name and ID'));
        fieldNameAndID = fs1.insert(getNameAndIdField());
        autoGenerateFieldID = fs1.insert(getAutoGeneratedFieldId(label, fieldNameAndID));

        var fs2 = base.insert(new jui.Component({elementType:'fieldset'}));
        fs2.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Box Height'));

        var numberOfLines = new jui.FormSliderInput({
          label:null,
          onchange: function(e) {
            var lines = e.data;
            self.setFieldAttribute('numberOfLines', lines);
            activeElement.root.e.down('textarea').style.height = (lines * 20) + 'px';
          },
          slider:{
            min:2,
            max:20,
            increment:1
          }
        });

        var pixelHeight = new jui.FormSliderInput({
          label:null,
          onchange: function(e) {
            var pixels = e.data;
            self.setFieldAttribute('pixelHeight', pixels);
            activeElement.root.e.down('textarea').style.height = pixels + 'px';
          },
          slider:{
            min:40,
            max:400,
            increment:1
          }
        });

        fs2.insert(numberOfLines);
        fs2.insert(pixelHeight);
        fs2.insert(new jui.FormSelect({
          label:null,
          id: 'jui-unit-select',
          selectOptions:[{name:'Lines', value:'lines'}, {name:'Pixels', value:'pixels'}],
          dropDownClassName: 'modal-select2-dropdown jui-drop-down',
          classNames:['textarea-height-units'],
          action: function(e) {
            var units = e.data;
            self.setFieldAttribute('heightUnits', units);
            if (units === 'lines') {
              numberOfLines.show();
              pixelHeight.hide();
              self.setFieldAttribute('numberOfLines', Math.round(self.activeField.pixelHeight / 20));
              numberOfLines.setValue(Math.round(self.activeField.pixelHeight / 20));
            } else {
              numberOfLines.hide();
              pixelHeight.show();
              self.setFieldAttribute('pixelHeight', self.activeField.numberOfLines * 20);
              pixelHeight.setValue(self.activeField.numberOfLines * 20);
            }
          }
        }));

        var fs3 = base.insert(new jui.Component({elementType:'fieldset'}));
        fs3.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Validation Options'));
        var required = fs3.insert(new jui.FormCheckboxInput({
          label: 'Required field',
          inputId: 'multi-line-text-required-checkbox',
          onclick: function(e) {
            self.setFieldAttribute('validations.required', e.source.getValue());
            var label = activeElement.root.e.down('label');
            self.toggleLabelAsReqired(label, e.source.getValue());
          }
        }));

        return {
          getRootElement: function() { return base;},
          setField: function(f, e) {
            activeField = f;
            activeElement = e;
            label.setValue(f.name);
            fieldNameAndID.setValue(f.id);
            setAutoGeneratedFieldNameAndId(f, autoGenerateFieldID, fieldNameAndID);
            hideLabel.setValue(f.hideLabel ? true : false);
            required.setValue(f.validations.required);
            numberOfLines.setValue(f.numberOfLines);
            pixelHeight.setValue(f.pixelHeight);

            if (f.heightUnits === 'lines') {
              numberOfLines.show();
              pixelHeight.hide();
              activeElement.root.e.down('textarea').style.height = (f.numberOfLines * 20) + 'px';
            } else {
              numberOfLines.hide();
              pixelHeight.show();
              activeElement.root.e.down('textarea').style.height = f.pixelHeight + 'px';
            }
          }
        };
      })()
    },

    {
      types:['hidden'],
      editor:(function() {
        var activeField = null;
        var activeElement = null;
        var base = new jui.Component({attributes:{className:'field-editor'}});
        var fs1 = base.insert(new jui.Component({elementType:'fieldset'}));

        fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Name and ID'));
        var fieldNameAndID = fs1.insert(new jui.FormTextInput({
          inputPosition:'clear-label',
          classNames:['field-name-id', 'disabled'],
          onkeyup: function(e) {
            var v = e.source.getValue().stripScripts();
            var id = self.sanitizeFieldId(v);
            self.setFieldAttribute('name', id);
            self.setFieldAttribute('id', id);
            activeElement.root.e.down('label').update(id);
            fieldNameAndID.setValue(id);
          }
        }));

        var fs2 = base.insert(new jui.Component({elementType:'fieldset'}));
        fs2.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Default Value'));
        var value = fs2.insert(new jui.FormTextInput({
          inputPosition:'clear-label',
          classNames:['label-input'],
          onkeyup: function(e) {
            self.setFieldAttribute('value', e.source.getValue().stripScripts());
            activeElement.root.e.down('input').value = e.source.getValue().stripScripts();
          }
        }));

        return {
          getRootElement: function() { return base;},
          setField: function(f, e) {
            activeField = f;
            activeElement = e;
            fieldNameAndID.setValue(f.id);
            value.setValue(f.value.stripScripts());
          }
        };
      })()
    },
      {
        types:['drop-down'],
        editor:(function() {
          var fieldNameAndID;
          var autoGenerateFieldID;

          var activeField = null;
          var activeElement = null;

          var base = new jui.Component({attributes:{className:'field-editor'}});
          var fs1 = base.insert(new jui.Component({elementType:'fieldset'}));
          fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Label'));
          var label = fs1.insert(new jui.FormTextInput({
            inputPosition:'clear-label',
            classNames:['label-input'],
            onkeyup: function(e) {
              var v = e.source.getValue().stripScripts();
              var id = self.generateFieldId(v);
              self.setFieldAttribute('name', v);
              activeElement.root.e.down('label').update(v);
              self._updateGeneratedFieldId(fieldNameAndID, autoGenerateFieldID, id);
            }
          }));

          var hideLabel = fs1.insert(new jui.FormCheckboxInput({
            label: 'Hide label',
            classNames: ['field-checkbox'],
            inputId: 'drop-down-text-hide-label-checkbox',
            onclick: function(e) {
              var hide = e.source.getValue();
              self.setFieldAttribute('hideLabel', hide);
              var visibility = hide ? 'hidden' : 'visible';
              activeElement.root.e.down('label').setStyle({'visibility': visibility});
            }
          }));

          fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Name and ID'));
          fieldNameAndID = fs1.insert(getNameAndIdField());
          autoGenerateFieldID = fs1.insert(getAutoGeneratedFieldId(label, fieldNameAndID));

          var fs3 = base.insert(new jui.Component({elementType:'fieldset'}));
          fs3.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Validation Options'));
          var firstInvalid = fs3.insert(new jui.FormCheckboxInput({
            label: 'First menu choice is not a valid value',
            inputId: 'first-invalid-checkbox',
            onclick: function(e) {
              self.setFieldAttribute('validations.required', e.source.getValue());
              self.setFieldAttribute('invalidOptions', e.source.getValue() ? [0] : []);
            }
          }));

          var fs2 = base.insert(new jui.Component({elementType:'fieldset'}));
          fs2.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Menu Choices'));
          var options = fs2.insert(new Element('div', {className:'edit-controls-options-list options-list clearfix'}));

          var createOption = function(value) {
            var option = new jui.Component({attributes:{className:'edit-controls-options-list-option option'}});
            option.insert(new Element('input', {type:'text', value:value}).observe('keyup',updateFieldOptions));
            option.insert(new jui.IconButton('add add-remove-button svg-ico-add-option', {action:insertOption.curry(option)}));
            option.insert(new jui.IconButton('delete add-remove-button svg-ico-delete-option', {action:removeOption.curry(option)}));
            return option;
          };
          var removeOption = function(option) {
            if (options.select('input').length > 1 ) {
              option.remove();
            } else {
              option.e.down('input').value = '';
            }

            updateFieldOptions();
          };

          var insertOption = function(option) {
            var optionElement = createOption( '' ).e;
            option.e.insert({after: optionElement});
            optionElement.down( 'input' ).focus();
            updateFieldOptions();
          };

          var updateFieldOptions = function() {
            var opts = options.select('input').collect(function(o) {
              return o.value.stripScripts();
            });
            self.setFieldAttribute('selectOptions', opts);
            activeElement.select.setSelectOptions(opts.collect(function(o) {return {name:o, value:o};}));
          };

          return {
            getRootElement: function() { return base;},
            setField: function(f,e) {
              activeField = f;
              activeElement = e;
              label.setValue(f.name);
              fieldNameAndID.setValue(f.id);
              setAutoGeneratedFieldNameAndId(f, autoGenerateFieldID, fieldNameAndID);

              hideLabel.setValue(f.hideLabel ? true : false);
              firstInvalid.setValue(f.validations.required && f.invalidOptions && f.invalidOptions.include(0));
              options.update();
              if (f.selectOptions.length === 0) {
                options.insert(createOption('').e);
              } else {
                f.selectOptions.each(function(o) {
                  options.insert(createOption(o).e);
                });
              }
            }
          };
        })()
      },
      {
        types:['checkbox-group'],
        editor:(function() {
          var fieldNameAndID;
          var autoGenerateFieldID;

          var activeField = null;
          var activeElement = null;

          var base = new jui.Component({attributes:{className:'field-editor'}});
          var fs1 = base.insert(new jui.Component({elementType:'fieldset'}));
          fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Label'));
          var label = fs1.insert(new jui.FormTextInput({
            inputPosition:'clear-label',
            classNames:['label-input'],
            onkeyup: function(e) {
              var v = e.source.getValue().stripScripts();
              var id = self.generateFieldId(v);
              self.setFieldAttribute('name', v);
              activeElement.root.e.down('label').update(v);
              self._updateGeneratedFieldId(fieldNameAndID, autoGenerateFieldID, id);
            }
          }));

          var hideLabel = fs1.insert(new jui.FormCheckboxInput({
            label:'Hide label',
            classNames:['field-checkbox'],
            inputId: 'checkbox-group-hide-label-checkbox',
            onclick: function(e) {
              var hide = e.source.getValue();
              self.setFieldAttribute('hideLabel', hide);
              var visibility = hide ? 'hidden' : 'visible';
              activeElement.root.e.down('label').setStyle({'visibility': visibility});
            }
          }));

          fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Name and ID'));
          fieldNameAndID = fs1.insert(getNameAndIdField());
          autoGenerateFieldID = fs1.insert(getAutoGeneratedFieldId(label, fieldNameAndID));

          var fs3 = base.insert(new jui.Component({elementType:'fieldset'}));
          fs3.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Validation Options'));
          var required = fs3.insert(new jui.FormCheckboxInput({
            label: 'Required field',
            inputId: 'checkbox-group-required-checkbox',
            onclick: function(e) {
              self.setFieldAttribute('validations.required', e.source.getValue());
              var label = activeElement.root.e.down('label');
              self.toggleLabelAsReqired(label, e.source.getValue());
            }
          }));

          var fs2 = base.insert(new jui.Component({elementType:'fieldset'}));
          fs2.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Checkbox Choices'));
          var optionsList = fs2.insert(new Element('div', {className:'options-list clearfix'}));

          var createOption = function(model) {
            var option = new jui.Component({attributes:{className:'option checkbox'}});
            option.insert(new Element('input', {type:'checkbox', checked:model.checked ? true : false}).observe('click',updateFieldOptions));
            option.insert(new Element('input', {type:'text', value:model.label}).observe('keyup',updateFieldOptions));
            option.insert(new jui.IconButton('add add-remove-button svg-ico-add-option', {action:insertOption.curry(option)}));
            option.insert(new jui.IconButton('delete add-remove-button svg-ico-delete-option', {action:removeOption.curry(option)}));
            return option;
          };
          var removeOption = function(option) {
            if (optionsList.select('input').length > 1 ) {
              option.remove();
            } else {
              option.e.down('input').value = '';
            }

            updateFieldOptions();
          };
          var insertOption = function(option) {
            option.e.insert({after:createOption({value:'', label:''}).e});
            updateFieldOptions();
          };
          var updateFieldOptions = function() {
            var opts = optionsList.select('div.option').collect(function(o) {
              var value = o.down('input[type="text"]').value.stripScripts();
              var checked = o.down('input[type="checkbox"]').checked;

              return {value:value, label:value, checked:checked};
            });
            self.setFieldAttribute('options', opts);
            activeElement.setOptions(opts);
          };

          return {
            getRootElement: function() { return base;},
            setField: function(f,e) {
              activeField = f;
              activeElement = e;
              label.setValue(f.name);
              fieldNameAndID.setValue(f.id);
              setAutoGeneratedFieldNameAndId(f, autoGenerateFieldID, fieldNameAndID);

              hideLabel.setValue(f.hideLabel ? true : false);
              required.setValue(f.validations.required);
              optionsList.update();
              if (f.options.length === 0) {
                optionsList.insert(createOption({value:'', label:''}).e);
              } else {
                f.options.each(function(o) {
                  optionsList.insert(createOption(o).e);
                });
              }
            }
          };
        })()
      },
        {
          types:['radio-group'],
          editor:(function() {
            var fieldNameAndID;
            var autoGenerateFieldID;

            var activeField = null;
            var activeElement = null;
            var checkedOption = null;

            var base = new jui.Component({attributes:{className:'field-editor'}});
            var fs1 = base.insert(new jui.Component({elementType:'fieldset'}));
            fs1.insert(new Element('h3', {className:'field-edit-controls-label'}, {className:'field-edit-controls-label'}).update('Field Label'));
            var label = fs1.insert(new jui.FormTextInput({
              inputPosition:'clear-label',
              classNames:['label-input'],
              onkeyup: function(e) {
                var v = e.source.getValue().stripScripts();
                var id = self.generateFieldId(v);
                self.setFieldAttribute('name', v);
                activeElement.root.e.down('label').update(v);
                self._updateGeneratedFieldId(fieldNameAndID, autoGenerateFieldID, id);
              }
            }));

            var hideLabel = fs1.insert(new jui.FormCheckboxInput({
              label: 'Hide label',
              classNames: ['field-checkbox'],
              inputId: 'radio-group-hide-label-checkbox',
              onclick: function(e) {
                var hide = e.source.getValue();
                self.setFieldAttribute('hideLabel', hide);
                var visibility = hide ? 'hidden' : 'visible';
                activeElement.root.e.down('label').setStyle({'visibility': visibility});
              }
            }));

            fs1.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Field Name and ID'));
            fieldNameAndID = fs1.insert(getNameAndIdField());
            autoGenerateFieldID = fs1.insert(getAutoGeneratedFieldId(label, fieldNameAndID));

            var fs3 = base.insert(new jui.Component({elementType:'fieldset'}));
            fs3.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Validation Options'));
            var required = fs3.insert(new jui.FormCheckboxInput({
              label: 'Required field',
              inputId: 'radio-group-required-checkbox',
              onclick: function(e) {
                self.setFieldAttribute('validations.required', e.source.getValue());
                var label = activeElement.root.e.down('label');
                self.toggleLabelAsReqired(label, e.source.getValue());
              }
            }));

            var fs2 = base.insert(new jui.Component({elementType:'fieldset'}));
            fs2.insert(new Element('h3', {className:'field-edit-controls-label'}).update('Radio Button Choices'));

            var optionsList = fs2.insert(new Element('div', {
              className:'options-list clearfix'
            }));

            //Create a random-ish name for the radio buttons in the form builder
            //so that you can only select one at a time.  Issue lp-6966
            var radioButtonName = 'radio-group-' + new Date().getTime();
            var createOption = function(model) {
              var option = new jui.Component({
                attributes:{className:'option checkbox'}
              });

              option.insert(new Element('input', {
                type:'radio',
                name: radioButtonName,
                checked:model.checked ? true : false
              }).observe('click',function() {changeCheckedOption(option);}));

              option.insert(new Element('input', {
                type:'text',
                value:model.label
              }).observe('keyup',updateFieldOptions));

              option.insert(new jui.IconButton('add add-remove-button svg-ico-add-option', {action:insertOption.curry(option)}));
              option.insert(new jui.IconButton('delete add-remove-button svg-ico-delete-option', {action:removeOption.curry(option)}));
              return option;
            };
            var removeOption = function(option) {
              if (optionsList.select('input').length > 1 ) {
                option.remove();
              } else {
                option.e.down('input').value = '';
              }

              updateFieldOptions();
            };
            var insertOption = function(option) {
              option.e.insert({after:createOption({value:'', label:''}).e});
              updateFieldOptions();
            };
            var changeCheckedOption  = function(option) {
              if (checkedOption === option) {
                option.e.down('input[type="radio"]').checked = false;
                checkedOption = null;
              } else {
                if (checkedOption !== null) {
                  checkedOption.e.down('input[type="radio"]').checked = false;
                }
                checkedOption = option;
              }
              updateFieldOptions();
            };
            var updateFieldOptions = function() {
              var opts = optionsList.select('div.option').collect(function(o) {
                var value = o.down('input[type="text"]').value.stripScripts();
                var checked = o.down('input[type="radio"]').checked;

                return {value:value, label:value, checked:checked};
              });
              self.setFieldAttribute('options', opts);
              activeElement.setOptions(opts);
            };

            return {
              getRootElement: function() { return base;},
              setField: function(f,e) {
                activeField = f;
                activeElement = e;
                label.setValue(f.name);
                fieldNameAndID.setValue(f.id);
                setAutoGeneratedFieldNameAndId(f, autoGenerateFieldID, fieldNameAndID);

                hideLabel.setValue(f.hideLabel ? true : false);
                required.setValue(f.validations.required);
                optionsList.update();
                if (f.options.length === 0) {
                  optionsList.insert(createOption({value:'', label:''}).e);
                } else {
                  f.options.each(function(o) {
                    optionsList.insert(createOption(o).e);
                  });
                }
              }
            };
          })()
        }
    ];
  },

  createFieldViews: function() {
    var self = this;

    var hideLabelOnView = function(f, label) {
      if (f.hideLabel) {
        label.setStyle({'visibility': 'hidden'});
      }
    };

    this.fieldViews = [
    {
      types:['single-line-text', 'email'],
      view: function(f){
        var root = new jui.Component({attributes:{className:'field clearfix'}});
        root.insert(new Element('div', {className:'hotspot'}));
        root.observe('click', self.fieldSelected.bindAsEventListener(self));
        var label = root.insert(new Element('label', {
          'for':'designer'+f.id,
          'class':'form-builder-section-label'
        }).update(
              f.validations.required ? f.name+' *' : f.name
              ));
        hideLabelOnView(f, label);
        if (window.editor.page.getConfigValue('showFormBuilderPlaceholderInput') && ubBanzai.features.isFormBuilderPlaceholderInputEnabled()) {
          root.insert(new Element('input', {
            id:'designer'+f.id,
            type:'text',
            className:'text form-builder-text-field',
            placeholder: f.placeholder || ''
          }));
        } else {
          root.insert(new Element('input', {id:'designer'+f.id, type:'text', className:'text form-builder-text-field'}));
        }
        return {root:root, label:label};
      }
    },
    {
      types:['multi-line-text'],
      view: function(f){
        var root = new jui.Component({attributes:{className:'field clearfix'}});
        root.insert(new Element('div', {className:'hotspot'}));
        root.observe('click', self.fieldSelected.bindAsEventListener(self));
        var label = root.insert(new Element('label', {
          'for':'designer'+f.id,
          'class':'form-builder-section-label'
        }).update(
              f.validations.required ? f.name+' *' : f.name
              ));
        hideLabelOnView(f, label);
        var input = root.insert(new Element('textarea', {id:'designer'+f.id, className:'text'}));
        input.style.height = (f.heightUnits === 'lines' ?
            f.numberOfLines * 20 :
            f.pixelHeight) + 'px';
        return {root:root, label:label};
      }
    },
      {
        types:['hidden'],
        view: function(f){
          var root = new jui.Component({attributes:{className:'field clearfix'}});
          root.insert(new Element('div', {className:'hotspot'}));
          root.observe('click', self.fieldSelected.bindAsEventListener(self));
          var label = root.insert(new Element('label', {
            'for':'designer'+f.id,
            className:'hidden form-builder-section-label'
          }).update(f.name));
          hideLabelOnView(f, label);
          root.insert(new Element('input', {id:'designer'+f.id, type:'text', className:'hidden', value:f.value}));
          return {root:root, label:label};
        }
      },
      {
        types:['drop-down'],
        view: function(f){
          var root = new jui.Component({attributes:{className:'field clearfix'}});
          root.insert(new Element('div', {className:'hotspot'}));
          root.observe('click', self.fieldSelected.bindAsEventListener(self));
          var select = root.insert(new jui.FormSelect({
            id:'designer'+f.id,
            label:f.validations.required ? f.name+' *' : f.name,
            selectOptions:f.selectOptions.collect(function(o){
              return {name:o, value:o};
            })
          }));
          hideLabelOnView(f, select.label);
          return {root:root, select:select};
        }
      },
        {
          types:['checkbox-group'],
          view: function(f){
            var root = new jui.Component({attributes:{className:'field clearfix'}});
            root.insert(new Element('div', {className:'hotspot'}));
            root.observe('click', self.fieldSelected.bindAsEventListener(self));
            var label = root.insert(new Element('label', {
              'for':'designer'+f.id,
              'class':'form-builder-section-label'
            }).update(
                  f.validations.required ? f.name+' *' : f.name
                  ));
            hideLabelOnView(f, label);
            var optionsList = root.insert(new jui.Component({attributes:{className:'optionsList'}}));
            var setOptions = function(options) {
              optionsList.clear();
              options.each(function(o) {
                optionsList.insert(new jui.FormCheckboxInput({
                  label:o.label,
                  labelClass: 'form-builder-checkbox-label',
                  checked:o.checked ? true : false
                }));
              });
            };

            setOptions(f.options);
            return {root:root, label:label, setOptions:setOptions};
          }
        },
        {
          types:['radio-group'],
          view: function(f){
            var root = new jui.Component({attributes:{className:'field clearfix'}});
            root.insert(new Element('div', {className:'hotspot'}));
            root.observe('click', self.fieldSelected.bindAsEventListener(self));
            var label = root.insert(new Element('label', {'for':'designer'+f.id}).update(
                  f.validations.required ? f.name+' *' : f.name
                  ));
            hideLabelOnView(f, label);
            var optionsList = root.insert(new jui.Component({attributes:{className:'optionsList'}}));
            var setOptions = function(options) {
              optionsList.clear();
              options.each(function(o) {
                optionsList.insert(new jui.FormRadioInput({
                  label:o.label,
                  labelClass: 'form-builder-radio-label',
                  checked:o.checked ? true : false
                }));
              });
            };

            setOptions(f.options);
            return {root:root, label:label, setOptions:setOptions};
          }
        }
    ];
  },

  validate: function() {
    var validator = new lp.module.form.FormBuilderValidator(this.fields);
    if(!validator.isValid()) {
      this.warn.update(validator.errorMessages());
      this.warn.show();
      this.actionButtons.doneButton.setEnabled(false);
    } else {
      this.warn.hide();
      this.actionButtons.doneButton.setEnabled(true);
    }
  },

  setFieldAttribute: function(accessor, value) {
    if (this.activeField === null) {
      return;
    }
    var arr = accessor.split('.');
    var attr = this.activeField;
    for (var i=0,l=arr.length;i < l;i++) {
      var attr2 = attr[arr[i]];
      attr = (typeof attr2 === "undefined") ? (attr[arr[i]] = (i < l-1) ? {} : value) : (i < l-1) ? attr2 : attr[arr[i]] = value;
    }
    this.validate();
  },

  addField: function(field) {
    this.lastAddedField = field;
    this.fields.push(field);
    this.updateFields();
    this.setActiveField(field);
  },

  deleteField: function() {
    if (this.activeField === null) {
      return;
    }

    this.fields = this.fields.without(this.activeField);
    this.editControls.clear();
    this.updateFields();
  },

  moveFieldUp: function() {
    if (this.activeField === null) {
      return;
    }

    var i = this.fields.indexOf(this.activeField);

    if (i > 0) {
      var field = this.activeField;
      var above = this.fields[i-1];
      this.fields[i-1] = this.activeField;
      this.fields[i] = above;
      this.updateFields();
      this.setActiveField(field);
    }
  },

  moveFieldDown: function() {
    if (this.activeField === null) {
      return;
    }

    var i = this.fields.indexOf(this.activeField);

    if (i < (this.fields.length - 1)) {
      var field = this.activeField;
      var below = this.fields[i+1];
      this.fields[i] = below;
      this.fields[i+1] = field;
      this.updateFields();
      this.setActiveField(field);
    }
  },

  updateFields: function() {
    this.fieldset.clear();
    this.elmMap = [];
    this.activeField = null;

    this.fields.each(function(f){
      var elm = this.fieldViews.find(function(view){return view.types.indexOf(f.lpType) > -1;}).view(f);
      this.fieldset.insert(elm.root);
      this.elmMap.push({elm:elm, field:f});
    }, this);
    this.validate();
  },

  fieldSelected: function(e) {
    e.stop();
    var field = this.elmMap.find(function(mapping){return mapping.elm.root.e === e.findElement('div.field');}).field;
    this.setActiveField(field);
  },

  setActiveField: function(field) {
    if (this.activeField !== null) {
      (this.elmMap.find(function(mapping){return mapping.field === this.activeField;}, this).elm.root.e).removeClassName('on');
    }

    this.activeField = field;
    var elm = this.elmMap.find(function(mapping){return mapping.field === field;}).elm;
    elm.root.e.addClassName('on');

    var elmRoot = elm.root;

    elmRoot = this.formItemControls;
    elm.root.insert(this.formItemControls);

    elmRoot.insert(this.moveUpButton.e);
    elmRoot.insert(this.moveDownButton.e);
    elmRoot.insert(this.deleteButton.e);


    var editor = this.fieldEditors.find(function(editor){return editor.types.indexOf(this.activeField.lpType) > -1;}, this).editor;

    if (this.editControls.e.firstDescendant() !== editor.getRootElement().e) {
      this.editControls.clear();
      this.editControls.insert(editor.getRootElement());
    }

    editor.setField(this.activeField, elm);
  },

  requestFocus: function(){
    window.editor.keyController.requestFocus(this);
  },

  onkeydown: _.noop,
  onkeyup:   _.noop,
  blur:      _.noop,

  close: function($super) {
    delete this.options.callback;
    $super();
  },

  open: function($super, form, options) {
    $super();
    if (options && options.callback) {
      this.options.callback = options.callback;
    }

    this.requestFocus();
    this.form = form;
    this.fields = (this.form !== null && this.form.model.exists('content.fields')) ? this.form.model.clone().content.fields : [];
    this.updateFields();
  }
}
);



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-form/form_element_builder.js
// module id = 1478
// module chunks = 0